import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import AuthLayout from '../components/AuthLayout';
import AccountDeletionFlow from '../components/AccountDeletionFlow';
import { auth } from '../firebaseConfig';
import { getAccountDeletionErrorMessage } from '../services/accountDeletionService';
import { requireConnectionForRemoteAccess } from '../services/connectivityService';
import './login.css';

const DeleteAccount = ({ currentUser, pending = false }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const login = async event => {
    event.preventDefault();
    setLoading(true); setError('');
    try {
      requireConnectionForRemoteAccess();
      await signInWithEmailAndPassword(auth, email.trim(), password);
      setPassword('');
    } catch (nextError) { setError(getAccountDeletionErrorMessage(nextError)); }
    finally { setLoading(false); }
  };

  return <AuthLayout title="Excluir conta Nara" subtitle="Página pública para excluir sua conta e os dados associados.">
    {!currentUser ? <>
      <p className="deletion-public-note">Entre com a própria conta. A exclusão não pode ser solicitada apenas informando um email e não exige instalar o aplicativo.</p>
      {error && <div className="auth-alert auth-alert--error" role="alert">{error}</div>}
      <form className="auth-form" onSubmit={login}>
        <label className="nf-field"><span>Email</span><input type="email" value={email} onChange={event => setEmail(event.target.value)} autoComplete="email" required /></label>
        <label className="nf-field"><span>Senha</span><input type="password" value={password} onChange={event => setPassword(event.target.value)} autoComplete="current-password" required /></label>
        <button className="auth-primary-button" disabled={loading} type="submit">{loading ? 'Entrando…' : 'Entrar para excluir'}</button>
      </form>
    </> : <AccountDeletionFlow pending={pending} />}
  </AuthLayout>;
};

export default DeleteAccount;
